import { Injectable } from '@angular/core';
import { MessageBannerConfig } from '@zipari/shared-ds-util-messages';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClaimSubmissionHttpService {
  saveClaimBannerConfig: BehaviorSubject<MessageBannerConfig> =
    new BehaviorSubject(null);
  saveClaimBannerConfig$: Observable<MessageBannerConfig> =
    this.saveClaimBannerConfig.asObservable();

  public handleSaveMessageBanner(
    bannerType,
    bannerMessage,
    bannerIcon,
    hideBanner,
  ): void {
    this.saveClaimBannerConfig.next({
      icon: bannerIcon,
      message: bannerMessage,
      type: bannerType,
      actionIcon: 'close',
      actionIconAltText: 'Close',
      hideBanner: hideBanner,
    });
  }
}
